import clsx from 'clsx';
import moment from 'moment';
import React from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';

export default function TimeAgo({ date, className }: { date: string; className?: string }) {
  const hydrated = useServerSideRendering();

  return (
    <span className={clsx('text-disclosure-sm', className)} title={date}>
      {hydrated && moment(date).fromNow()}
    </span>
  );
}
